export default __webpack_public_path__ + "static/media/settings_regions_img.bf6a32b9.svg";